import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||323}
    height={undefined}
    fill="none"
    style={{aspectRatio: 323/300}}
    viewBox="0 0 323 300"
    {...props}
  >
    <path
      stroke="#435288"
      strokeDasharray="15.33 15.33"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M79.287 2h163.089c36.247 0 65.67 29.423 65.67 65.67V231.9c0 36.246-29.423 65.669-65.67 65.669H78.146c-36.247 0-65.67-29.423-65.67-65.669V68.811C12.476 31.933 42.416 2 79.286 2Z"
    />
    <path
      fill="#fff"
      d="M288.921 67.676v164.231c0 25.686-20.852 46.539-46.538 46.539H78.151c-25.686 0-46.538-20.853-46.538-46.539V68.811c0-26.318 21.362-47.68 47.68-47.68h163.09c25.686 0 46.538 20.852 46.538 46.538v.007Z"
      opacity={0.9}
    />
    <path
      fill="#24EAA8"
      d="M131.081 79H68.857a5.465 5.465 0 0 0-5.456 5.456v109.659a5.465 5.465 0 0 0 5.456 5.456h62.224c11.899 0 21.581 9.682 21.581 21.581a5.464 5.464 0 0 0 5.456 5.456 5.464 5.464 0 0 0 5.456-5.456V111.494c0-17.919-14.575-32.494-32.493-32.494Zm21.581 32.494v85.378a32.303 32.303 0 0 0-21.581-8.214H74.319v-98.74h56.762c11.899 0 21.581 9.682 21.581 21.581v-.005Z"
    />
    <path
      fill="#425596"
      d="M247.379 79h-62.224c-17.918 0-32.493 14.575-32.493 32.494v109.658a5.464 5.464 0 0 0 5.456 5.456 5.464 5.464 0 0 0 5.456-5.456c0-11.899 9.682-21.581 21.581-21.581h62.224a5.466 5.466 0 0 0 5.457-5.456V84.456A5.465 5.465 0 0 0 247.379 79Zm-5.462 10.912v98.741h-56.762a32.302 32.302 0 0 0-21.581 8.213v-85.372c0-11.9 9.682-21.582 21.581-21.582h56.762Z"
    />
    <path
      fill="#FF7458"
      d="M243.502 206.113h-53.424c-10.46 0-18.975 8.509-18.975 18.974a5.465 5.465 0 0 0 5.456 5.457 5.465 5.465 0 0 0 5.456-5.457c0-4.446 3.616-8.062 8.063-8.062h53.424a5.464 5.464 0 0 0 5.456-5.456 5.464 5.464 0 0 0-5.456-5.456Z"
    />
    <path
      fill="#425596"
      d="M127.163 206.113H73.738a5.464 5.464 0 0 0-5.456 5.456 5.464 5.464 0 0 0 5.456 5.456h53.425c4.446 0 8.062 3.616 8.062 8.062a5.466 5.466 0 0 0 5.456 5.457 5.466 5.466 0 0 0 5.457-5.457c0-10.465-8.51-18.974-18.975-18.974Z"
    />
    <path
      fill="#24EAA8"
      d="M12 114c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z"
    />
    <path
      fill="#FF7458"
      d="M322.585 211.111 308.24 186l-14.354 25.111h28.699Z"
    />
  </svg>
)
export default SvgComponent
